const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Celebrity%20red%20carpet%20event%20with%20dramatic%20lighting%20and%20paparazzi%20cameras%2C%20dark%20luxurious%20atmosphere%2C%20entertainment%20industry%20theme%2C%20warm%20golden%20accents%2C%20glamorous%20but%20mysterious%20mood&width=500&height=350&seq=card-01&orientation=landscape',
    tag: '丑闻细节',
    title: '某男星被前女友曝出轨实锤截图，时间线完整梳理',
    date: '2026-07-29',
    hot: true,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20backstage%20of%20concert%20venue%20with%20musical%20instruments%20in%20shadows%2C%20dramatic%20single%20spotlight%2C%20mysterious%20atmosphere%2C%20entertainment%20industry%20setting%2C%20warm%20amber%20lighting&width=500&height=350&seq=card-02&orientation=landscape',
    tag: '娱乐八卦',
    title: '知名歌手涉嫌假唱风波升级，演唱会现场音频对比分析',
    date: '2026-07-28',
    hot: true,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Luxury%20restaurant%20private%20dining%20room%20with%20empty%20table%20and%20elegant%20place%20settings%2C%20warm%20candlelight%2C%20dark%20intimate%20atmosphere%2C%20mysterious%20mood%2C%20editorial%20photography&width=500&height=350&seq=card-03&orientation=landscape',
    tag: '私生活',
    title: '顶流情侣被拍同居实锤，双方粉丝反应激烈互撕升级',
    date: '2026-07-27',
    hot: false,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Film%20production%20set%20with%20camera%20rig%20and%20equipment%2C%20dramatic%20lighting%20setup%2C%20dark%20studio%20atmosphere%2C%20behind%20the%20scenes%20cinematic%20look%2C%20warm%20tungsten%20lights&width=500&height=350&seq=card-04&orientation=landscape',
    tag: '内幕曝光',
    title: '某导演被曝潜规则女演员，多位业内人士匿名揭发',
    date: '2026-07-26',
    hot: true,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Award%20ceremony%20stage%20with%20empty%20trophy%20under%20spotlight%2C%20dark%20theater%20setting%2C%20dramatic%20atmosphere%2C%20prestigious%20event%20vibe%2C%20warm%20gold%20and%20black%20contrast&width=500&height=350&seq=card-05&orientation=landscape',
    tag: '颁奖黑幕',
    title: '年度颁奖典礼票数造假曝光，观众投票原来只是走过场',
    date: '2026-07-25',
    hot: false,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20social%20media%20posts%20in%20dark%20room%2C%20dramatic%20glow%20from%20screen%2C%20mysterious%20mood%2C%20digital%20age%20entertainment%20news%2C%20warm%20contrast%20lighting&width=500&height=350&seq=card-06&orientation=landscape',
    tag: '饭圈风云',
    title: '两大顶流粉丝互扒黑料持续升级，双方工作室紧急发声',
    date: '2026-07-24',
    hot: true,
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门瓜料
          </h2>
          <p className="text-foreground-500 text-sm">最新娱乐八卦黑料 · 持续更新中</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((item, i) => (
            <article
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={i > 2 ? 'lazy' : undefined}
                />
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2.5 py-1 bg-accent-500/90 text-white text-xs font-medium rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                  {item.hot && (
                    <span className="px-2 py-1 bg-primary-500/90 text-white text-xs font-bold rounded-md whitespace-nowrap">
                      HOT
                    </span>
                  )}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-bold text-foreground-950 mb-3 leading-snug line-clamp-2 font-heading">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line"></i>
                    热议中
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}